module.exports = __webpack_public_path__ + "static/desktop/img/step-tablet-photobook.535922e4.png";